"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const config_dev_json_1 = __importDefault(require("./config.dev.json"));
const config_test_json_1 = __importDefault(require("./config.test.json"));
const config_base_json_1 = __importDefault(require("./config.base.json"));
const config_prod_json_1 = __importDefault(require("./config.prod.json"));
const config_staging_json_1 = __importDefault(require("./config.staging.json"));
const envConfigs = {
    development: Object.assign(Object.assign({}, config_base_json_1.default), config_dev_json_1.default),
    test: Object.assign({}, config_test_json_1.default),
    staging: Object.assign(Object.assign({}, config_base_json_1.default), config_staging_json_1.default),
    production: Object.assign(Object.assign({}, config_base_json_1.default), config_prod_json_1.default),
};
const envKey = process.env.CONFIG_ENV || "production";
if (!(envKey in envConfigs))
    throw new Error(`${envKey} is not a valid env config`);
const config = envConfigs[envKey];
exports.default = config;
